import { defineComponent as _defineComponent } from 'vue'
import AdSetName from '@/views/Automation/CampaignCreatorV2/steps/AdSetCards/AdSetName.ts.vue';
import AudienceControls from '@/views/Automation/CampaignCreatorV2/steps/AdSetCards/AudienceControls.ts.vue';
import BudgetAndSchedule from '@/views/Automation/CampaignCreatorV2/steps/AdSetCards/BudgetAndSchedule.ts.vue';
import Conversions from '@/views/Automation/CampaignCreatorV2/steps/AdSetCards/Conversions.ts.vue';
import Placements from '@/views/Automation/CampaignCreatorV2/steps/AdSetCards/Placements.ts.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AdSetTab.ts',
  setup(__props) {


return { __sfc: true,AdSetName, AudienceControls, BudgetAndSchedule, Conversions, Placements }
}

})